@if (getFormControl()) {
	@if (!data?.isAggregateRow) {
		<pms-always-set-currency-input [min]="params.min" #currencyInput [formControl]="getFormControl()"></pms-always-set-currency-input>
	}
}
